import ProductItem from '../components/ProductItem';

export default class Static404 {
  constructor(section) {
    this.el = section.el;
    this.productEls = this.el.querySelectorAll('[data-product-item]');
    this.products = [];

    for (let i = 0; i < this.productEls.length; i++) {
      this.products.push(new ProductItem(this.productEls[i]));
    }
  }

  onSectionUnload() {
    this.products.forEach(product => product.unload());
  }
}
